<template>
  <v-dialog v-model="dialog" width="auto" height="auto">
    <v-card color="#f9f9f9">
      <div class="d-flex py-3 px-3">
        <h2 class="mr-1">Model specified on</h2>
        <h2 class="primary--text" v-text="machineIdentifierText(machine)" />
        <v-spacer></v-spacer>
        <v-btn dark color="tertiary" class="mr-3">Change model</v-btn>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-card elevation="5" class="rounded-t-lg">
        <v-row no-gutters>
          <!-- Image -->
          <v-col cols="auto">
            <MachineModelImage :size="350">
            </MachineModelImage>
          </v-col>
          <v-divider vertical></v-divider>
          <!-- Details -->
          <v-col cols="0" class="py-2 px-4" style="max-width: 700px;">
            <!-- Header -->
            <v-row no-gutters>
              <v-col cols="0">
                <h2 v-text="model && model.Name" />
                <h3 class="grey--text" v-text="model && model.AlternativeName" />
              </v-col>
              <v-col cols="auto" class="d-flex flex-column justify-center py-1">
                <v-row no-gutters>
                  <v-col cols="auto" class="d-flex flex-column align-end justify-space-between mr-3">
                    <p class="mb-0 mt-1">Type:</p>
                    <p class="mb-0">Supplier:</p>
                  </v-col>
                  <v-col cols="auto" class="d-flex flex-column align-start justify-space-between">
                    <v-chip color="primary">
                      <h4 v-text="model && model.MachineType && model.MachineType.Name" />
                    </v-chip>
                    <h4 v-text="model && model.Supplier && model.Supplier.Name" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- Description -->
            <v-row no-gutters class="my-3">
              {{ model && model.ModelDescription }}
            </v-row>
            <!-- Parent model -->
            <v-row no-gutters v-if="model && model.Parent">
              <v-card class="d-flex align-center" width="100%"
                style="background-color: #f2f8ff; border: 1px solid #8194f6;">
                <p class="mx-3 mb-0">This model is a variation of</p>
                <v-list-item dense style="max-width: 60%;">
                  <v-list-item-icon class="ma-auto mr-3 d-flex align-center" style="height: unset;">
                    <MachineModelImage :size="48">
                    </MachineModelImage>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ model.Parent.Name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ model.Parent.AlternativeName }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-card>
            </v-row>
            <!-- More info -->
            <v-row no-gutters class="my-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
              ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </v-row>
          </v-col>
        </v-row>

      </v-card>
    </v-card>
  </v-dialog>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineMixin from "@/helpers/Mixins/MachineMixin.js";
import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";

export default {
  name: 'MachineModelDialog2',
  props: {
    show: Boolean,
    machine: Object,
    modelId: [Number, String],
  },
  model: {
    prop: "show",
    event: "showEvent",
  },
  components: {
    MachineModelImage,
  },
  mixins: [MachineMixin],

  data() {
    return {
      dialog: false,
      model: null,
      modelLoading: false,
    };
  },

  methods: {
    getMachineModel() {
      this.modelLoading = true;
      clientAPI.methods.getModelById(this.modelId)
        .then((response) => {
          this.model = response;
        }).finally(() => {
          this.modelLoading = false;
        });
      //console.log('model', this.model);
    },
  },

  computed: {},

  watch: {
    show: function () {
      if (this.show != this.dialog) {
        this.dialog = this.show;
        this.getMachineModel();
      }
    },

    dialog: function () {
      if (this.show != this.dialog) {
        this.$emit("showEvent", this.dialog);
      }
    },
  },
};
</script>


<style lang='scss' scoped></style>